// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1Frmb","list":"BalanceDue_list__2E_yG","listRow":"BalanceDue_listRow__tViSh","total":"BalanceDue_total__1Oh8W"};